import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { TableLoader } from '@livable/saas-react-components';
import { Alert, Container,
// Checkbox,
Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NoDataPlaceholder from 'src/components/shared/NoDataPlaceholder';
import StatementsBatchActions from 'src/components/statements/StatementsBatchActions';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import ActionBar from './ActionBar';
import StatementTableRow from './StatementTableRow';
import useStyles from './styles';
import { toJS } from 'mobx';
export default function StatementsTable(_ref) {
  let propertyId = _ref.propertyId;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(new Date(moment().subtract(1, 'months').endOf('month'))),
    _useState4 = _slicedToArray(_useState3, 2),
    pickerDate = _useState4[0],
    setPickerDate = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedRows = _useState6[0],
    setSelectedRows = _useState6[1];
  const getCurrentCycle = async data => {
    const resp = await store.allocations.getCurrentCycleAsync.run(data);
    return resp;
  };
  const getPropertyStatements = async () => {
    const resp = await store.statement.getPropertyStatementsAsync.run({
      month: pickerDate.getMonth() + 1,
      propertyId,
      year: pickerDate.getFullYear()
    });
    return resp;
  };
  useEffect(() => {
    getCurrentCycle({
      companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setIsLoading(true);
    getPropertyStatements().finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pickerDate]);
  const handleRowSelection = row => {
    if (!selectedRows.includes(row.id)) {
      setSelectedRows(prevIds => [...prevIds, row.id]);
    } else {
      setSelectedRows(prevIds => prevIds.filter(selectedId => selectedId !== row.id));
    }
  };

  // const handleBatchSelection = () => {
  //   const selectedRowsCount = selectedRows.length;
  //   const statementsRowsCount = statementsRows.length;

  //   if (!selectedRowsCount) {
  //     setSelectedRows(
  //       statementsRows.map(row => {
  //         if (!row.vacant) {
  //           return row.id;
  //         }
  //         return undefined;
  //       })
  //     );
  //   } else if (statementsRowsCount > selectedRowsCount) {
  //     setSelectedRows([]);
  //   } else if (statementsRowsCount === selectedRowsCount) {
  //     setSelectedRows([]);
  //   }
  //   return undefined;
  // };

  const handleBatchDeselect = () => setSelectedRows([]);

  // function getCheckboxIcon() {
  //   if (!selectedRows.length) {
  //     return (
  //       <div className={classes.blankCheckbox}>
  //         <Icon type="checkbox" />
  //       </div>
  //     );
  //   }
  //   if (statementsRows.length > selectedRows.length) {
  //     return (
  //       <div className={classes.activeCheckbox}>
  //         <Icon type="checkbox-deselect" />
  //       </div>
  //     );
  //   }
  //   if (statementsRows.length === selectedRows.length) {
  //     return <Icon type="checkbox-selected" />;
  //   }
  //   return undefined;
  // }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "".concat(classes.containerDefault, " ").concat(selectedRows.length > 0 ? classes.containerSmall : '')
  }, /*#__PURE__*/React.createElement(ActionBar, {
    pickerDate: pickerDate,
    setPickerDate: setPickerDate
  }), /*#__PURE__*/React.createElement(TableContainer, {
    className: classes.tableContainer
  }, store.statement.getPropertyStatementsAsync.inProgress || isLoading ? /*#__PURE__*/React.createElement(TableLoader, null) : store.statement.propertyStatements.length === 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    icon: false,
    severity: "warning",
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('residencies_page.statements_not_issued')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('residencies_page.statements_will_be_send_out', {
    date: moment(store.allocations.currentCycle.statementDate).format('L'),
    days: store.allocations.currentCycle.daysTillStatementDate,
    interpolation: {
      escapeValue: false
    }
  }))), /*#__PURE__*/React.createElement(NoDataPlaceholder, {
    text: "No statements"
  })) : /*#__PURE__*/React.createElement(Table, {
    "aria-label": "statements table",
    size: "small",
    type: "fullWidth",
    className: classes.table
  }, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, t('residencies_page.unit_name_cell')), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.cellXl
  }, t('residencies_page.active_residents_statements_table')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('general.charges')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('general.credits')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('residencies_page.utility_bills')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('residencies_page.utility_caps')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('residencies_page.statement_caps')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('general.total')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('general.toolbox')))), /*#__PURE__*/React.createElement(TableBody, null, toJS(store.statement.propertyStatements).sort((a, b) => {
    var _ref2;
    return (_ref2 = '' + (a === null || a === void 0 ? void 0 : a.unitName)) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(b === null || b === void 0 ? void 0 : b.unitName, undefined, {
      numeric: true
    });
  }).map(row => /*#__PURE__*/React.createElement(StatementTableRow, {
    row: row,
    key: row.id,
    handleRowSelection: handleRowSelection,
    isSelected: selectedRows.includes(row.id)
  })))))), selectedRows.length > 0 && /*#__PURE__*/React.createElement(StatementsBatchActions, {
    selectCount: selectedRows.length,
    handleBatchDeselect: handleBatchDeselect
  }));
}